import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import cart from '@/store/cart';
import campaign from '@/store/campaign';
import user from '@/store/user';
import roaming from '@/store/roaming';
import accounthistory from '@/store/accounthistory';
import inventory from '@/store/inventory';
import payment from '@/store/payment';
import safetyNumbers from '@/store/safetyNumbers';

const vuexPersist = new VuexPersistence({
  strictMode: process.env.NODE_ENV !== 'production',
  storage: window.sessionStorage,
  reducer: state => {
    const stateToSave = {
      user: {
        user: state.user.user,
        key: state.user.key,
      },
      cart: {
        cart: state.cart.cart,
        activeSlide: state.cart.activeSlide,
      },
      inventory: {
        discounts: state.inventory.discounts,
      },
      campaign: {
        personalCampaigns: state.campaign.personalCampaigns,
      },
    };
    return stateToSave;
  },
});
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    cart,
    user,
    inventory,
    payment,
    campaign,
    roaming,
    safetyNumbers,
    accounthistory,
  },
  mutations: {
    RESTORE_MUTATION: vuexPersist.RESTORE_MUTATION, // this mutation **MUST** be named "RESTORE_MUTATION"
  },
  plugins: [vuexPersist.plugin],
  strict: process.env.NODE_ENV !== 'production',
});
store.watch(
  (_state, getters) => getters['user/user'],
  (user, oldUser) => {
    if (user.authenticated) {
      const cart = store.getters['cart/cart'];
      if (user.serviceClassGroup !== cart.serviceClass) {
        store.dispatch('cart/clearSaldo');
        store.dispatch('cart/clearPacket');
      }
      if (!user.canPurchasePacket) {
        store.dispatch('cart/clearPacket');
      }
      store.dispatch(
        'cart/addSaldo',
        Math.min(user.saldoPossibleToLoad, cart.saldo)
      );
    } else if (oldUser.authenticated) {
      store.dispatch('cart/clearSaldo');
      store.dispatch('cart/clearPacket');
    }
    if (!user.authenticated) {
      store.dispatch('inventory/clearDiscounts');
      store.dispatch('campaign/clear');
      store.dispatch('cart/clearSaldoDiscount');
    }
  }
);
export default store;
